import { render } from "./InputDigitalSignature.vue?vue&type=template&id=4b91a0ae&scoped=true"
import script from "./InputDigitalSignature.vue?vue&type=script&lang=js"
export * from "./InputDigitalSignature.vue?vue&type=script&lang=js"

import "./InputDigitalSignature.vue?vue&type=style&index=0&id=4b91a0ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b91a0ae"]])

export default __exports__